// extracted by mini-css-extract-plugin
export default {"noizeCanvas":"NoizeGraf_noizeCanvas__dfljL"};